import * as actionTypes from "../constants/actionTypes";

export const initialState = {
  byIds: {},
  allIds: [],
  loaded: false
};

function setFolder(state, folder) {
  const byIds = { ...state.byIds, [folder.id]: folder };
  const allIds = Object.keys(byIds);

  return {
    ...state,
    byIds,
    allIds
  };
}

function setFolders(state, folders) {
  return {
    ...state,
    byIds: folders,
    allIds: Object.keys(folders),
    loaded: true
  };
}

function unsetFolder(state, id) {
  const byIds = state.allIds.reduce((acc, index) => {
    if (id !== index) {
      acc[index] = state.byIds[index];
    }

    return acc;
  }, {});

  return {
    ...state,
    byIds,
    allIds: Object.keys(byIds)
  };
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FOLDER:
      return setFolder(state, action.payload.folder);
    case actionTypes.SET_FOLDERS:
      return setFolders(state, action.payload.folders);
    case actionTypes.UNSET_FOLDER:
      return unsetFolder(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/folders.js